import React, { useContext, useEffect } from 'react';
import { reportMixPanel } from '@55degrees/consent-tracker';
import MixPanelContext from '../../contexts/MixPanelContext';
import useAppTheme from '../../hooks/useAppTheme';
import useSavedDatasets from '../../hooks/useSavedDatasets';
import DataTable from './data-table/DataTable';
import FeaturesOverview from './features-overview/FeaturesOverview';
import HelpSection from './help-section/HelpSection';
import Hero from './hero/Hero';
import { LandingPageProps } from './types';
import { LandingPageDivider, LandingPageTopContainer, LandingPageWrapper } from './style';
import { A3DocumentContext } from '../../contexts/A3DocumentContext';

function LandingPage({ loadDataset, openDataLoader }: LandingPageProps) {
  const { isMobile, isLaptop, isWideScreen } = useAppTheme();
  const { loadA3ExampleData } = useContext(A3DocumentContext);
  const { isMixPanelInitialized } = useContext(MixPanelContext);
  const { allStrippedDatasets, isLoading: isLoadingDatasets } = useSavedDatasets();

  useEffect(() => {
    const numberOfDatasets = allStrippedDatasets?.length || 0;
    if (isMixPanelInitialized && !isLoadingDatasets) {
      reportMixPanel('Landing Page Load', {
        'Num of Data Sets': numberOfDatasets,
      });
    }
  }, [isMixPanelInitialized, allStrippedDatasets?.length, isLoadingDatasets]);

  return (
    <LandingPageWrapper>
      <LandingPageTopContainer ismobile={isMobile} islaptop={isLaptop} iswidescreen={isWideScreen}>
        <Hero openDataLoaderDialog={openDataLoader} loadExampleData={loadA3ExampleData} />
        <DataTable openDataLoaderDialog={openDataLoader} loadDataset={loadDataset} />
      </LandingPageTopContainer>
      <LandingPageDivider />
      <FeaturesOverview />
      <HelpSection />
    </LandingPageWrapper>
  );
}

export default LandingPage;
